import React, { useMemo } from "react";
import Flx from "../layout/Flx";
import { grey } from "@mui/material/colors";
import Txt from "../typography/Txt";

const SubsectionHeader = ({ icon, title, onClick, children, sx, titleSx }) => {
  const styles = useMemo(() => {
    return sx;
  }, [sx]);

  const titleStyles = useMemo(() => {
    const baseStyles = {};
    if (onClick) {
      baseStyles.cursor = "pointer";
      baseStyles["&:hover"] = { color: grey[900], textDecoration: "underline" };
    }
    return {
      ...baseStyles,
      ...titleSx,
    };
  }, [titleSx, onClick]);

  return (
    <Flx
      ac
      gap={0.8}
      sx={{
        mb: 1,
        color: "#000000ad",
        // color: grey[900],
        //
        width: "100%",
        ...styles,
      }}
    >
      {icon}
      <Txt
        className="subsection-header-title"
        sx={{ fontWeight: 400, fontSize: "14px", ...titleStyles }}
        onClick={onClick}
      >
        {title}
      </Txt>

      {children}
    </Flx>
  );
};

export default SubsectionHeader;
